// constants
import { DURATION, EASING } from 'shared/components/SmartProductJourney/constants';

// Video players keep closed settings dialogs mounted inside the PDP.
export const hasVisibleDialog = () =>
  Array.from(document.querySelectorAll<HTMLElement>('[role="dialog"]:not([data-product-journey])'))
    .some((dialog) => {
      if (dialog.closest('[hidden], [aria-hidden="true"]') || !dialog.getClientRects().length) return false;
      const { visibility, display } = window.getComputedStyle(dialog);
      return display !== 'none' && visibility !== 'hidden' && visibility !== 'collapse';
    });

export const getStagePosition = (next: number, height: number, animated = false) => {
  const offset = Math.max(0, Math.min(next, height));
  return {
    offset,
    transition: animated ? `transform ${DURATION}ms ${EASING}` : 'none',
    routeTransform: `translate3d(0, ${height - offset}px, 0)`,
    carouselTransform: `translate3d(0, ${-offset}px, 0)`,
  };
};

export const getJourneyDestination = (url: string, currentUrl: string, rootHref: string) => {
  const destination = new URL(url, currentUrl);
  if (destination.origin !== new URL(currentUrl).origin) return;
  // Browser history adds its basename; public product URLs already include it.
  const basename = rootHref.replace(/\/$/, '');
  const pathname = basename && destination.pathname.startsWith(`${basename}/`)
    ? destination.pathname.slice(basename.length) : destination.pathname;
  return `${pathname}${destination.search}${destination.hash}`;
};
